@if (subNavigationTabs?.length) {
    <ms-scroll-adapter class="scrolling-pills">
        <div class="header-sub-navigation-pills">
            @for (item of subNavigationTabs; track item.id) {
                <button ds-pill size="small" [selected]="item.active" (click)="tabSelected($event, item.id)">
                    {{ item.name }}
                </button>
            }
        </div>
    </ms-scroll-adapter>
}
